import { buildFirebaseStorageMediaURL } from '@/util/storageMediaUrls';

let amplitudeAPIKey;
let appURL;
let buildStorageMediaURL;
let chromeExtensionId;
let crispWebsiteID;
let gumroadApplicationId;
let linkedInApplicationId;
let facebookApplicationId;
let threadsApplicationId;
let youtubeApplicationId;
let youtubeAPIKey;
let httpRoutesURL;
let instagramApplicationId;
let isAppDeployed;
let isEnvProd;
let redirectURI;
let retweeterURL;
let servicebotBillingPageID;
let tweetGetterURL;
let hypefuryAccountTwitterId;
let twitterLoginRedirectURI;
let messagingVapidKey;
let paddleInfo;
let hypefuryUrlShortenerURL;
let tweetReelPreviewURL;
let tiktokClientKey;

const AERIELAB_PROD_APP_URL = 'https://app.aerielab.co';
const LOCAL_APP_URL = process.env.VUE_APP_URL || 'http://localhost:8080';

function getAppURL(appURL) {
  return process.env.NODE_ENV === 'production' ? appURL : LOCAL_APP_URL;
}

function getFrontendAppInfo(projectId) {
  switch (projectId) {
    case 'hypefury-896c7':
      return { appURL: getAppURL(AERIELAB_PROD_APP_URL), environment: 'prod' };
    case 'curious-meadow':
      return { appURL: getAppURL(AERIELAB_PROD_APP_URL), environment: 'prod' };
    case 'hypefury-staging':
      return { appURL: `https://${projectId}.firebaseapp.com`, environment: 'staging' };
    case 'hypefury-dev':
      return {
        appURL:
          process.env.NODE_ENV === 'production'
            ? `https://${projectId}.firebaseapp.com`
            : LOCAL_APP_URL,
        environment: 'dev',
      };
    case 'hypefury-e2e':
      return {
        appURL:
          process.env.NODE_ENV === 'production'
            ? `https://${projectId}.firebaseapp.com`
            : LOCAL_APP_URL,
        environment: 'e2e',
      };
    case `hypefury-${process.env.VUE_APP_LOCAL_ENV}-dev`:
      return {
        appURL: LOCAL_APP_URL,
        environment: `${process.env.VUE_APP_LOCAL_ENV}-dev`,
      };
    case 'not-a-project':
      return { appURL: '', environment: '' };
    default:
      throw new Error(`Environment ${projectId} unknown.`);
  }
}

export function build(firebase) {
  const appInfo = getFrontendAppInfo(firebase.projectId);
  const environment = appInfo.environment;
  isEnvProd = environment === 'prod';

  hypefuryUrlShortenerURL = isEnvProd
    ? 'https://hfl.ink'
    : 'https://link-shortener-server-development.up.railway.app';

  tweetReelPreviewURL = (() => {
    if (!isEnvProd && process.env.VUE_APP_REEL === 'local') {
      return 'http://localhost:5173';
    }
    return 'https://tweet-to-reel.vercel.app';
  })();

  amplitudeAPIKey = isEnvProd
    ? '2c8edf521679207bef79d932b65d13bd'
    : 'c1670c24cf9df2094bc0a1c553905af8';

  appURL = appInfo.appURL;

  isAppDeployed = process.env.NODE_ENV === 'production';

  chromeExtensionId = isEnvProd ? 'eoobmkmdlgpnpegpccclfjbedcpkmdmi' : 'febkjdegjijhmidbhhdhokfaihiphpli';

  crispWebsiteID = isEnvProd
    ? '4c0ca013-6fbe-4fc4-a784-701169988631'
    : '6ba74aab-cb6e-4db9-bd03-007d0edfd5b4';

  gumroadApplicationId = (() => {
    switch (environment) {
      case 'prod':
        return '7cd27f1e825921ebec53fa2e283820b3bcddc152b080392e7a2e451e2e8572c7';
      case 'staging':
        return '4f510df7677c781f150d60114f960293e0a4e23ef60cef71b8acf75868367c8d';
      case 'dev':
        if (process.env.NODE_ENV === 'production') {
          return 'b0b9124b6ed5b195b5d0fb05f5190085cb00414758c00728a4ce1f676022d5f6';
        } else {
          return '88cdb2e1085c32634dc78b8f6a19f6540ebeffc39a1085e126f44f6d9bbd6448';
        }
      case `${process.env.VUE_APP_LOCAL_ENV}-dev`:
        return '88cdb2e1085c32634dc78b8f6a19f6540ebeffc39a1085e126f44f6d9bbd6448';
      case 'e2e':
        return '88cdb2e1085c32634dc78b8f6a19f6540ebeffc39a1085e126f44f6d9bbd6448';
      default:
        throw new Error(`Environment ${environment} unknown.`);
    }
  })();

  redirectURI = appURL + '/settings';

  linkedInApplicationId = isEnvProd ? '77aihk6l9qshme' : '77h1kvqh39cuye';

  instagramApplicationId = '626193984926772';

  facebookApplicationId = '626193984926772';

  threadsApplicationId = '25746248308355573';

  youtubeApplicationId = isEnvProd
    ? '560600773755-mvhtsdvdg4lsb5hg1vg8qg6336eb2hih.apps.googleusercontent.com'
    : '6976844171-9imoe2h394vl10niaqk65qfrali5qgk7.apps.googleusercontent.com';

  httpRoutesURL = isAppDeployed
    ? `${appURL}/api`
    : `http://localhost:5001/${firebase.projectId}/us-central1/httpRoutes/api`;

  buildStorageMediaURL = (mediaName) => {
    return buildFirebaseStorageMediaURL(firebase.projectId, mediaName, firebase.storageBucket);
  };

  servicebotBillingPageID = isEnvProd ? 'Y1qQSOBGdpjwcVNIfY0H' : 'WZ6BxpiF1ETZfYUZrX7Y';

  hypefuryAccountTwitterId = '1160721354649460736';
  twitterLoginRedirectURI = appURL;

  messagingVapidKey = isEnvProd
    ? 'BJvRnmpTnt-GVkdesvUd3-eH8-6RgdHSlN3I6AOYalqoSAW2omad8PsHaCfEuFnK6CZwVmpPDUSXpwdAiN4fsTk'
    : 'BEUCUvR3CKO7yQ2k2HwWESXHnVPcDcO058qkw0LrCLCdonyKfpYxWTYevQHwp4LqVggfaVGMm_uKqGlywExRH0I';

  paddleInfo = isEnvProd
    ? {
        vendorId: 150796,
        plans: {
          premiumMonthly: '786131',
          premiumYearly: '786132',
          standardMonthly: '786129',
          standardYearly: '786130',
          basicMonthly: '879228',
          basicYearly: '879227',
          agencyMonthly: '878285',
          agencyYearly: '878284',
          businessMonthly: '878282',
          businessYearly: '878283',
        },
        trialPlans: {
          standardMonthly: '902128',
          standardYearly: '902129',
          premiumMonthly: '902130',
          premiumYearly: '902131',
          agencyMonthly: '902132',
          agencyYearly: '902133',
          businessMonthly: '902134',
          businessYearly: '902135',
        },
      }
    : {
        vendorId: 6198,
        plans: {
          premiumMonthly: '28966',
          premiumYearly: '31626',
          standardMonthly: '28965',
          standardYearly: '31627',
          basicMonthly: '48121',
          basicYearly: '48122',
          agencyMonthly: '51172',
          agencyYearly: '51171',
          businessMonthly: '51170',
          businessYearly: '51169',
        },
        trialPlans: {
          standardMonthly: '72477',
          standardYearly: '72478',
          premiumMonthly: '72479',
          premiumYearly: '72480',
          agencyMonthly: '72481',
          agencyYearly: '72482',
          businessMonthly: '72483',
          businessYearly: '72484',
        },
      };

  tiktokClientKey = 'awg7jvdajwaskglf';
  return {
    amplitudeAPIKey,
    appURL,
    buildStorageMediaURL,
    chromeExtensionId,
    crispWebsiteID,
    facebookApplicationId,
    threadsApplicationId,
    gumroadApplicationId,
    linkedInApplicationId,
    httpRoutesURL,
    instagramApplicationId,
    isAppDeployed,
    isEnvProd,
    redirectURI,
    retweeterURL,
    servicebotBillingPageID,
    tweetGetterURL,
    hypefuryAccountTwitterId,
    twitterLoginRedirectURI,
    messagingVapidKey,
    paddleInfo,
    tiktokClientKey,
  };
}

export {
  amplitudeAPIKey,
  appURL,
  buildStorageMediaURL,
  chromeExtensionId,
  crispWebsiteID,
  facebookApplicationId,
  threadsApplicationId,
  gumroadApplicationId,
  linkedInApplicationId,
  httpRoutesURL,
  instagramApplicationId,
  youtubeAPIKey,
  youtubeApplicationId,
  isAppDeployed,
  isEnvProd,
  redirectURI,
  retweeterURL,
  servicebotBillingPageID,
  tweetGetterURL,
  hypefuryAccountTwitterId,
  twitterLoginRedirectURI,
  paddleInfo,
  hypefuryUrlShortenerURL,
  tweetReelPreviewURL,
  tiktokClientKey,
};
